export default __webpack_public_path__ + "static/media/Img0027.08cdef7c.png";